import SEOHead from '../components/SEOHead';
import { imageUrl } from '../lib/images';

export default function BetingelserPage() {
  return (
    <>
      <SEOHead
        title="Betingelser & Privatliv | Djurs Massage"
        description="Læs om handelsbetingelser for gavekort, afbudspolitik og persondatabeskyttelse hos Djurs Massage i Ryomgård. Tryg og gennemskuelig klinik."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/omsorgsfuld-behandling-haender-velvaere.jpeg"
      />

      {/* Clean page header - NO container box, NO paragraph above heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Betingelser og databeskyttelse
          </h1>
          <p className="text-slate-700 text-sm sm:text-base mt-3 leading-relaxed font-normal">
            Hos Djurs Massage i Ryomgård, Danmark, er vi dedikerede til effektiv behandling og gennemsigtighed. Her finder du information om vores handelsbetingelser og hvordan vi beskytter dine data.
          </p>
        </div>
      </div>

      {/* Content directly on page canvas - NO card boxes wrapping headings and text */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 space-y-10">
        {/* Handelsbetingelser Section */}
        <div className="pt-2 space-y-6">
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif mb-1">
              Handelsbetingelser
            </h2>
            <p className="text-slate-600 text-sm">
              Nedenfor finder du vores handelsbetingelser. Vi anbefaler at du læser dem grundigt igennem.
            </p>
          </div>

          <div className="py-4 border-y border-[#E8E1D5] text-xs sm:text-sm text-slate-700 space-y-1">
            <div className="font-bold text-sm sm:text-base text-[#1E3A5F]">
              Handelsbetingelser for køb af gavekort
            </div>
            <div className="font-semibold text-slate-900 pt-1">Djurs Massage</div>
            <div>Poppelvej 52, 8550 Ryomgård</div>
            <div>CVR-nr.: 28053150</div>
            <div>
              E-mail:{' '}
              <a href="mailto:djursmassage@gmail.com" className="underline hover:text-[#1E3A5F]">
                djursmassage@gmail.com
              </a>
            </div>
            <div>
              Telefon:{' '}
              <a href="tel:28583907" className="underline hover:text-[#1E3A5F]">
                28 58 39 07
              </a>
            </div>
          </div>

          {/* Sections 1 to 7 */}
          <div className="space-y-6 text-xs sm:text-sm text-slate-700 leading-relaxed">
            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">1. Generelt</h3>
              <p>
                Disse handelsbetingelser gælder for køb og anvendelse af gavekort udstedt af <strong>Djurs Massage</strong>. Ved køb af gavekort accepteres disse vilkår.
              </p>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">2. Gyldighed</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Gavekortet er gyldigt i <strong>3 år</strong> fra købsdatoen.</li>
                <li>Efter udløbsdatoen kan gavekortet ikke anvendes eller forlænges.</li>
              </ul>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">3. Anvendelse</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Gavekortet kan bruges til betaling af massagebehandlinger hos <strong>Djurs Massage</strong>.</li>
                <li>Gavekortet kan ikke indløses til kontanter.</li>
                <li>Hvis værdien af gavekortet overstiger prisen på den valgte behandling, kan restbeløbet bruges ved en senere behandling inden for gyldighedsperioden.</li>
              </ul>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">4. Køb og betaling</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Gavekort kan købes online via hjemmeside eller fysisk i klinikken.</li>
                <li>Vi modtager betaling med Dankort, MobilePay, m.fl..</li>
                <li>Alle beløb er i danske kroner (DKK).</li>
              </ul>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">5. Fortrydelsesret</h3>
              <ul className="list-disc pl-5 space-y-1">
                <li>Ved køb af gavekort online har du 14 dages fortrydelsesret fra købsdatoen, forudsat at gavekortet ikke er indløst.</li>
                <li>Fortrydelsesretten gælder ikke ved køb i klinikken, medmindre andet er aftalt.</li>
              </ul>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">6. Bortkomst</h3>
              <p>
                Gavekort behandles som kontanter. Mistede eller stjålne gavekort erstattes ikke.
              </p>
            </section>

            <section className="space-y-1.5">
              <h3 className="text-sm sm:text-base font-bold text-[#1E3A5F] font-serif">7. Persondata</h3>
              <p>
                Ved køb af gavekort registreres de oplysninger, du giver os (navn, e-mail, telefonnummer). Disse anvendes kun til at administrere dit køb og i overensstemmelse med vores Databeskyttelse.
              </p>
            </section>
          </div>
        </div>

        {/* Databeskyttelse Section */}
        <div className="pt-6 border-t border-[#E8E1D5] space-y-6">
          <div className="space-y-3">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif">
              Databeskyttelse hos Djurs Massage
            </h2>
            <p className="text-slate-700 text-xs sm:text-sm leading-relaxed">
              Hos Djurs Massage tager vi din databeskyttelse alvorligt. Vi har et lukket system, hvor vi ikke gemmer personfølsomme data, for at sikre dine oplysninger bedst muligt.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
